import { render, staticRenderFns } from "./editAgreements.vue?vue&type=template&id=9ed8d0a2&"
import script from "./editAgreements.vue?vue&type=script&lang=js&"
export * from "./editAgreements.vue?vue&type=script&lang=js&"
import style0 from "./editAgreements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports